import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api, { getTwitchRedirectUri } from '../api';
import { AUTH_MESSAGE, useTwitchAuth } from '../context/TwitchAuthContext';
import { useSiteConfig } from '../context/SiteConfigContext';
import { Muted, Page, Title, GlobalStyle } from '../components/ui';

const TwitchCallbackPage: React.FC = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setSession } = useTwitchAuth();
  const { auctionsPublicEnabled, loading } = useSiteConfig();
  const [error, setError] = useState('');

  useEffect(() => {
    if (loading) return;

    const afterLoginPath = auctionsPublicEnabled ? '/subastas' : '/';

    const oauthError = params.get('error');
    if (oauthError) {
      setError(params.get('error_description') || oauthError);
      return;
    }

    const code = params.get('code');
    if (!code) {
      navigate(afterLoginPath, { replace: true });
      return;
    }

    const legacyRedirect = params.get('oauth_redirect_uri');
    const redirectUri = legacyRedirect || getTwitchRedirectUri();

    api.post('/twitch/auth/callback', { code, redirect_uri: redirectUri })
      .then(({ data }) => {
        if (window.opener && !window.opener.closed) {
          window.opener.postMessage(
            { type: AUTH_MESSAGE, token: data.token, user: data.user },
            window.location.origin,
          );
          window.close();
          return;
        }
        setSession(data.token, data.user);
        navigate(afterLoginPath, { replace: true });
      })
      .catch((err) => {
        const msg = err?.response?.data?.message;
        setError(msg || 'Error al iniciar sesión con Twitch');
      });
  }, [params, navigate, setSession, auctionsPublicEnabled, loading]);

  if (error) {
    return (
      <>
        <GlobalStyle />
        <Page>
          <Title>Error de login</Title>
          <Muted>{error}</Muted>
        </Page>
      </>
    );
  }

  return (
    <>
      <GlobalStyle />
      <Page>
        <Title>Conectando Twitch...</Title>
        <Muted>Esperá un momento.</Muted>
      </Page>
    </>
  );
};

export default TwitchCallbackPage;
